import { disablePush } from "./push";
import { createContext, useCallback, useContext, useEffect, useState } from "react";
import { api, setToken } from "./api";

const AuthCtx = createContext(null);

export function AuthProvider({ children }) {
  const [user, setUser] = useState(null);
  const [loading, setLoading] = useState(true);

  const refresh = useCallback(async () => {
    try {
      const r = await api.get("/auth/me");
      setUser(r.data);
    } catch {
      setUser(null);
    } finally {
      setLoading(false);
    }
  }, []);

  useEffect(() => {
    // Returning from Google: AuthCallback exchanges the session first.
    if (window.location.hash?.includes("session_id=")) {
      setLoading(false);
      return;
    }
    refresh();
  }, [refresh]);

  const signIn = (data) => {
    setToken(data.session_token);
    setUser(data.user);
    refresh();
  };
  const logout = async () => {
    await disablePush().catch(() => {});
    try {
      await api.post("/auth/logout");
    } catch {}
    setToken(null);
    setUser(null);
  };

  return <AuthCtx.Provider value={{ user, loading, signIn, logout, refresh }}>{children}</AuthCtx.Provider>;
}

export const useAuth = () => useContext(AuthCtx);
